/* GGC Racing "Build your stage" - vehicle -> Stage 1/2/3 -> parts verified to fit, running total, add-all-to-cart.
 *
 * Data (all static theme assets, no backend):
 *   ggc-stages.json            stage + step definitions (edit and re-upload to change steps)
 *   ggc-stage-<make>.json      per-make index: t[vehicleTag][stepId] = [total, productKey, trimMask, ...]
 *                              p[productKey] = {h handle, n title, b brand, i image, v [[variantId, title, price, compareAt, inStock]], c closeout}
 *                              tr[vehicleTag] = trim/engine labels (bit order of trimMask)
 *   ggc-ymm-index.json         year -> make -> model -> vehicle tag (only loaded to pick/change a vehicle)
 *
 * Fitment is never inferred. A part is listed only if the index says it carries this vehicle's fitment tag (or a
 * year/make/model fits_ tag), AND its title years do not exclude the model year (same safety net as ggc-fit.js).
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-ggc-stage]');
  if (!root) return;

  var BASE = root.getAttribute('data-base') || '';
  var IMG = 'https://cdn.shopify.com/s/files/1/0552/3210/2484/files/';
  var ACTIVE_KEY = 'ggc_ymm_active', GARAGE_KEY = 'ggc_ymm_garage';

  var cfg = null, shard = null, tree = null;
  var v = null;                 // vehicle {year, make, model, tag, label}
  var stageId = 'stage1', trim = '';
  var steps = {};               // stepId -> {def, stageId, opts, pick, vid, on, win}
  var added = null;

  /* ---------- helpers ---------- */
  function $(s, r) { return (r || root).querySelector(s); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function readJSON(k, f) { try { return JSON.parse(localStorage.getItem(k)) || f; } catch (e) { return f; } }
  function writeJSON(k, val) { try { localStorage.setItem(k, JSON.stringify(val)); } catch (e) {} }
  function money(n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function getJSON(u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function qs() { var o = {}; location.search.replace(/^\?/, '').split('&').forEach(function (p) { if (!p) return; var a = p.split('='); o[decodeURIComponent(a[0])] = decodeURIComponent((a[1] || '').replace(/\+/g, ' ')); }); return o; }
  function imgUrl(i, w) {
    if (!i) return '';
    var u = i.charAt(0) === '~' ? IMG + i.slice(1) : i;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 360);
  }

  /* title-year safety net (port of ggc-fit.js titleExcludes) */
  function fullYear(n) { n = parseInt(n, 10); return n < 100 ? (n >= 30 ? 1900 + n : 2000 + n) : n; }
  function titleExcludes(title, vy, make) {
    if (!vy) return false;
    var spans = [], re = /\b((?:19|20)\d{2}|\d{2})\s*[-\u2013]\s*((?:19|20)\d{2}|\d{2})\b/g, m;
    var t = title.replace(/\d+\s*\/\s*\d+/g, ' ');
    while ((m = re.exec(t))) { var a = fullYear(m[1]), b = fullYear(m[2]); if (a <= b && a >= 1930 && b <= 2035) spans.push([a, b]); }
    (t.match(/\b(?:19[3-9]\d|20[0-3]\d)\b/g) || []).forEach(function (y) {
      y = parseInt(y, 10);
      if (!spans.some(function (s) { return y >= s[0] && y <= s[1]; })) spans.push([y, y]);
    });
    if (make) {   // a lone 2-digit year directly before the vehicle's make ("DBA 08 Subaru WRX ...") is a model year
      var re2 = new RegExp('(^|[\\s(,])(\\d{2})\\s+' + make.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'ig'), m2;
      while ((m2 = re2.exec(t))) {
        var y2 = fullYear(m2[2]);
        if (y2 >= 1980 && y2 <= 2035 && !spans.some(function (s) { return y2 >= s[0] && y2 <= s[1]; })) spans.push([y2, y2]);
      }
    }
    if (!spans.length) return false;
    return !spans.some(function (s) { return vy >= s[0] && vy <= s[1]; });
  }

  /* ---------- vehicle ---------- */
  function vehicleFromStore() {
    var a = readJSON(ACTIVE_KEY, null);
    if (a && a.tag && a.make && a.year) return a;
    var g = readJSON(GARAGE_KEY, []).filter(function (x) { return x && x.tag && x.make && x.year && !x.handle; });
    return g[0] || null;
  }
  function saveVehicle(veh) {
    writeJSON(ACTIVE_KEY, veh);
    var g = readJSON(GARAGE_KEY, []);
    if (!g.some(function (x) { return x.tag === veh.tag && x.label === veh.label; })) { g.unshift(veh); writeJSON(GARAGE_KEY, g.slice(0, 12)); }
  }
  function loadTree() {
    if (tree) return Promise.resolve(tree);
    return getJSON(root.getAttribute('data-index-url')).then(function (d) { tree = d.tree; return tree; });
  }

  /* ---------- model ---------- */
  function stagesChain(id) {      // ordered stage ids from the base up to id, following "includes"
    var out = [], seen = {};
    (function add(sid) {
      if (seen[sid]) return; seen[sid] = 1;
      var st = cfg.stages.filter(function (s) { return s.id === sid; })[0];
      if (!st) return;
      (st.includes || []).forEach(add);
      out.push(st);
    })(id);
    return out;
  }
  function trimBit() {
    if (!trim || !shard) return 0;
    var list = shard.tr[v.tag] || [], i = list.indexOf(trim);
    return i < 0 ? 0 : (1 << i);
  }
  function optionsFor(step) {
    var e = shard.t[v.tag] && shard.t[v.tag][step.id];
    if (!e) return [];
    var bit = trimBit(), vy = parseInt(v.year, 10), out = [];
    for (var i = 1; i < e.length; i += 2) {
      var p = shard.p[e[i]], m = e[i + 1];
      if (!p || titleExcludes(p.n, vy, v.make)) continue;
      if (bit && m && !(m & bit)) continue;           // part lists specific trims and not this one
      out.push({ p: p, ver: !!(bit && (m & bit)) });
    }
    if (bit) out.sort(function (a, b) { return (a.ver ? 0 : 1) - (b.ver ? 0 : 1); });   // stable-ish: verified-trim first
    return out.slice(0, cfg.maxOptions || 6);
  }
  function bestVariant(p) {   // cheapest in-stock variant (index already ordered by price, in-stock first when any)
    for (var i = 0; i < p.v.length; i++) if (p.v[i][4]) return p.v[i];
    return p.v[0];
  }
  function buildSteps() {
    var prev = steps; steps = {};
    cfg.stages.forEach(function (st) {
      st.steps.forEach(function (def) {
        var opts = optionsFor(def), old = prev[def.id];
        var s = { def: def, stageId: st.id, opts: opts, pick: 0, vid: null, on: true, win: 0 };
        if (old && old.opts.length && opts.length) {          // keep the shopper's choice when only the trim/stage changed
          var h = old.opts[old.pick] && old.opts[old.pick].p.h;
          for (var i = 0; i < opts.length; i++) if (opts[i].p.h === h) { s.pick = i; s.vid = old.vid; break; }
          s.on = old.on;
        }
        if (opts.length && !s.vid) s.vid = bestVariant(opts[s.pick].p)[0];
        steps[def.id] = s;
      });
    });
  }
  function visibleSteps(sid) {   // [{stage, steps:[...]}] for the chosen stage and everything it includes
    return stagesChain(sid).map(function (st) {
      return { stage: st, steps: st.steps.map(function (d) { return steps[d.id]; }).filter(function (s) { return !(s.def.turboOnly && !s.opts.length); }) };
    });
  }
  function chosen(s) {
    if (!s.opts.length) return null;
    var p = s.opts[s.pick].p;
    for (var i = 0; i < p.v.length; i++) if (p.v[i][0] === s.vid) return { p: p, v: p.v[i] };
    return { p: p, v: bestVariant(p) };
  }
  function summary(sid) {
    var items = [], total = 0, steps_ = 0, withFit = 0;
    visibleSteps(sid).forEach(function (g) {
      g.steps.forEach(function (s) {
        steps_++;
        if (s.opts.length) withFit++;
        if (!s.on) return;
        var c = chosen(s); if (!c || !c.v[4]) return;
        items.push({ id: c.v[0], qty: 1, p: c.p, step: s });
        total += parseFloat(c.v[2]);
      });
    });
    return { items: items, total: total, steps: steps_, fit: withFit };
  }
  function stageCoverage(st) {
    var chain = stagesChain(st.id), n = 0, fit = 0;
    chain.forEach(function (c) { c.steps.forEach(function (d) { var s = steps[d.id]; if (d.turboOnly && !s.opts.length) return; n++; if (s.opts.length) fit++; }); });
    return { n: n, fit: fit };
  }

  /* ---------- rendering ---------- */
  function badges(p, v_) {
    var h = '';
    if (p.c) h += '<span class="sb-badge sb-badge--closeout">Closeout</span>';
    if (v_[3] && parseFloat(v_[3]) > parseFloat(v_[2])) h += '<span class="sb-badge sb-badge--sale">Sale</span>';
    return h ? '<span class="sb-badges">' + h + '</span>' : '';
  }
  function optionCard(s, i, o) {
    var p = o.p, selected = i === s.pick;
    var vv = selected ? chosen(s).v : bestVariant(p);
    var inStock = vv[4];
    var price = parseFloat(vv[2]), cmp = vv[3] ? parseFloat(vv[3]) : 0;
    var name = 'sb-' + s.def.id;
    var fitTxt = o.ver ? 'Verified for ' + esc(trim) : 'Fits your ' + esc(v.label);
    var h = '<div class="sb-opt' + (selected ? ' is-selected' : '') + (inStock ? '' : ' is-out') + '">';
    h += '<label class="sb-opt__pick"><input type="radio" class="sb-opt__radio" name="' + name + '" data-act="pick" data-step="' + s.def.id + '" data-i="' + i + '"' + (selected ? ' checked' : '') + '>';
    h += '<span class="sb-opt__media">' + badges(p, vv) + (p.i ? '<img src="' + esc(imgUrl(p.i, 360)) + '" alt="" loading="lazy" width="180" height="180">' : '<span class="sb-opt__noimg">No image</span>') + '</span>';
    h += '<span class="sb-opt__body"><span class="sb-opt__brand">' + esc(p.b) + '</span><span class="sb-opt__title">' + esc(p.n) + '</span>';
    h += '<span class="sb-opt__price"><b>' + money(price) + '</b>' + (cmp > price ? ' <s>' + money(cmp) + '</s>' : '') + '</span>';
    h += '<span class="sb-opt__meta"><span class="sb-fit' + (o.ver ? ' sb-fit--trim' : '') + '">' + fitTxt + '</span>' + (inStock ? '' : '<span class="sb-oos">Out of stock</span>') + '</span></span>';
    h += '<span class="sb-opt__check" aria-hidden="true"></span></label>';
    h += '<div class="sb-opt__foot">';
    if (selected && p.v.length > 1) {
      h += '<select class="sb-opt__var" data-act="variant" data-step="' + s.def.id + '" aria-label="Option for ' + esc(p.n) + '">';
      p.v.forEach(function (x) { h += '<option value="' + x[0] + '"' + (x[0] === s.vid ? ' selected' : '') + (x[4] ? '' : ' disabled') + '>' + esc(x[1] || 'Standard') + ' - ' + money(x[2]) + (x[4] ? '' : ' (sold out)') + '</option>'; });
      h += '</select>';
    }
    h += '<a class="sb-opt__view" href="/products/' + esc(p.h) + '" target="_blank" rel="noopener">View part</a></div></div>';
    return h;
  }
  function stepCard(s, n) {
    var d = s.def, c = chosen(s), h = '';
    h += '<article class="sb-step' + (s.opts.length ? '' : ' is-empty') + (s.on ? '' : ' is-off') + '" data-step-card="' + d.id + '">';
    h += '<header class="sb-step__head"><span class="sb-step__n">' + (n < 10 ? '0' + n : n) + '</span><div class="sb-step__t"><h3>' + esc(d.label) + '</h3><p>' + esc(d.why) + '</p></div>';
    if (s.opts.length) {
      h += '<label class="sb-incl"><input type="checkbox" data-act="toggle" data-step="' + d.id + '"' + (s.on ? ' checked' : '') + '><span>Include</span></label>';
    }
    h += '</header>';
    if (s.opts.length) {
      var win = s.win, size = 3, shown = s.opts.slice(win, win + size);
      if (shown.length < size) shown = shown.concat(s.opts.slice(0, size - shown.length));
      h += '<div class="sb-opts">';
      shown.forEach(function (o) { h += optionCard(s, s.opts.indexOf(o), o); });
      h += '</div>';
      h += '<div class="sb-step__foot"><span class="sb-step__sel">' + (s.on && c ? 'Selected: <b>' + esc(c.p.b) + '</b> ' + money(c.v[2]) : 'Not in this build') + '</span>';
      if (s.opts.length > size) h += '<button type="button" class="sb-swap" data-act="swap" data-step="' + d.id + '">Swap options <span>(' + s.opts.length + ' verified)</span></button>';
      h += '</div>';
    } else {
      h += '<div class="sb-none"><div><strong>No verified-fit part yet</strong><span>We only list parts confirmed for your ' + esc(v.label) + '. Ask us and we will source one.</span></div>';
      h += '<div class="sb-none__act"><button type="button" class="sb-btn sb-btn--ghost" data-act="ask" data-step="' + d.id + '">Ask us</button>';
      if (d.altLink) h += '<a class="sb-link" href="' + esc(d.altLink.href) + '">' + esc(d.altLink.label) + '</a>';
      h += '</div></div>';
    }
    h += '</article>';
    return h;
  }

  function render() {
    var h = '';
    var st = cfg.stages.filter(function (x) { return x.id === stageId; })[0];
    /* vehicle bar */
    h += '<section class="sb-veh"><div class="sb-veh__main"><span class="sb-eyebrow">Your ride</span><strong class="sb-veh__name">' + esc(v.label) + '</strong>';
    h += '<button type="button" class="sb-link" data-act="change">Change vehicle</button></div>';
    var trims = shard.tr[v.tag] || [];
    if (trims.length) {
      h += '<div class="sb-trims" role="group" aria-label="Narrow by trim or engine"><span class="sb-trims__l">Trim / engine <em>(optional)</em></span>';
      h += '<button type="button" class="sb-chip' + (!trim ? ' is-on' : '') + '" data-act="trim" data-trim="">All</button>';
      trims.forEach(function (t) { h += '<button type="button" class="sb-chip' + (trim === t ? ' is-on' : '') + '" data-act="trim" data-trim="' + esc(t) + '">' + esc(t) + '</button>'; });
      h += '</div>';
    }
    h += '</section>';
    /* stage cards */
    h += '<div class="sb-stages" role="tablist" aria-label="Performance stage">';
    cfg.stages.forEach(function (s2, idx) {
      var cov = stageCoverage(s2);
      h += '<button type="button" role="tab" aria-selected="' + (s2.id === stageId) + '" class="sb-stage' + (s2.id === stageId ? ' is-on' : '') + '" data-act="stage" data-stage="' + s2.id + '">';
      h += '<span class="sb-stage__k">' + esc(s2.label) + '</span><span class="sb-stage__t">' + esc(s2.tagline) + '</span>';
      h += '<span class="sb-stage__c"><b>' + cov.fit + '</b> of ' + cov.n + ' steps verified</span></button>';
    });
    h += '</div>';
    h += '<p class="sb-blurb">' + esc(st.blurb) + '</p>';
    /* steps */
    var n = 0, hiddenTurbo = 0;
    visibleSteps(stageId).forEach(function (g) {
      if (!g.steps.length) return;
      if (g.stage.id !== stageId || stagesChain(stageId).length > 1) h += '<h2 class="sb-group">' + (g.stage.id === stageId ? 'Added in ' + esc(g.stage.label) : 'From ' + esc(g.stage.label)) + '</h2>';
      g.steps.forEach(function (s) { n++; h += stepCard(s, n); });
    });
    stagesChain(stageId).forEach(function (g) { g.steps.forEach(function (d) { if (d.turboOnly && !steps[d.id].opts.length) hiddenTurbo++; }); });
    if (hiddenTurbo) h += '<p class="sb-note">' + hiddenTurbo + ' turbo-only step' + (hiddenTurbo > 1 ? 's are' : ' is') + ' hidden because we have no verified turbo parts for your ' + esc(v.label) + '.</p>';
    /* summary */
    var sm = summary(stageId);
    h += '<div class="sb-bar" data-bar><div class="sb-bar__in"><div class="sb-bar__t"><span class="sb-bar__l">' + esc(st.label) + ' build</span>';
    h += '<span class="sb-bar__n">' + sm.items.length + ' part' + (sm.items.length === 1 ? '' : 's') + '</span><strong class="sb-bar__total" data-total>' + money(sm.total) + '</strong></div>';
    h += '<button type="button" class="sb-btn" data-act="addall"' + (sm.items.length ? '' : ' disabled') + '>Add ' + esc(st.label) + ' to cart</button></div>';
    h += '<div class="sb-bar__msg" data-msg role="status" aria-live="polite"></div></div>';
    root.querySelector('[data-stage-body]').innerHTML = h;
    if (added) showMsg(added.html, added.err);
  }

  function showMsg(html, err) {
    var m = $('[data-msg]'); if (!m) return;
    m.innerHTML = html; m.className = 'sb-bar__msg' + (err ? ' is-err' : (html ? ' is-ok' : ''));
  }

  /* ---------- picker (no vehicle / change vehicle) ---------- */
  function renderPicker(msg) {
    var g = readJSON(GARAGE_KEY, []).filter(function (x) { return x && x.tag && x.make && x.year && !x.handle; });
    var h = '<section class="sb-pick"><span class="sb-eyebrow">Step 1</span><h2>Pick your ride</h2><p>' + (msg || 'We list only parts confirmed for your exact year, make and model.') + '</p>';
    if (g.length) {
      h += '<div class="sb-garage"><span class="sb-garage__l">Your garage</span>';
      g.forEach(function (x, i) { h += '<button type="button" class="sb-chip" data-act="garage" data-i="' + i + '">' + esc(x.label) + '</button>'; });
      h += '</div>';
    }
    h += '<div class="sb-fields"><label>Year<select data-sel="year" disabled><option>Loading...</option></select></label>';
    h += '<label>Make<select data-sel="make" disabled><option value="">-Choose-</option></select></label>';
    h += '<label>Model<select data-sel="model" disabled><option value="">-Choose-</option></select></label>';
    h += '<button type="button" class="sb-btn" data-act="start" disabled>Build my stage</button></div></section>';
    root.querySelector('[data-stage-body]').innerHTML = h;
    loadTree().then(function (t) {
      var ys = Object.keys(t).sort(function (a, b) { return b - a; });
      var sy = $('[data-sel=year]'); sy.innerHTML = '<option value="">-Choose-</option>' + ys.map(function (y) { return '<option>' + y + '</option>'; }).join(''); sy.disabled = false;
    }).catch(function () { var sy = $('[data-sel=year]'); if (sy) sy.innerHTML = '<option>Could not load. Reload to retry.</option>'; });
  }
  function fillSel(sel, vals) { sel.innerHTML = '<option value="">-Choose-</option>' + vals.map(function (x) { return '<option>' + esc(x) + '</option>'; }).join(''); sel.disabled = !vals.length; }

  /* ---------- load a vehicle ---------- */
  function setVehicle(veh, keepStage) {
    v = { year: String(veh.year), make: veh.make, model: veh.model, tag: veh.tag, label: veh.label || [veh.year, veh.make, veh.model].join(' ') };
    saveVehicle(v);
    trim = '';
    root.setAttribute('aria-busy', 'true');
    root.querySelector('[data-stage-body]').innerHTML = '<p class="sb-loading">Loading verified parts for your ' + esc(v.label) + '...</p>';
    return getJSON(BASE + 'ggc-stage-' + norm(v.make) + '.json?v=' + (cfg.ver || '0')).then(function (d) { shard = d; }).catch(function () { shard = { t: {}, p: {}, tr: {} }; })
      .then(function () { buildSteps(); root.removeAttribute('aria-busy'); render(); syncUrl(); });
  }
  function syncUrl() {
    try { history.replaceState(null, '', location.pathname + '?stage=' + stageId.replace('stage', '') + (trim ? '&trim=' + encodeURIComponent(trim) : '')); } catch (e) {}
  }

  /* ---------- events ---------- */
  function stepOf(el) { return steps[el.getAttribute('data-step')]; }
  root.addEventListener('change', function (e) {
    var t = e.target, act = t.getAttribute('data-act');
    if (act === 'pick') { var s = stepOf(t); s.pick = parseInt(t.getAttribute('data-i'), 10); s.vid = bestVariant(s.opts[s.pick].p)[0]; added = null; render(); return; }
    if (act === 'variant') { var s2 = stepOf(t); s2.vid = parseInt(t.value, 10); added = null; render(); return; }
    if (act === 'toggle') { stepOf(t).on = t.checked; added = null; render(); return; }
    var sel = t.getAttribute('data-sel');
    if (sel === 'year') {
      var ms = Object.keys(tree[t.value] || {}).sort(); fillSel($('[data-sel=make]'), ms); fillSel($('[data-sel=model]'), []); $('[data-act=start]').disabled = true;
    } else if (sel === 'make') {
      var y = $('[data-sel=year]').value, md = Object.keys((tree[y] || {})[t.value] || {}).sort(); fillSel($('[data-sel=model]'), md); $('[data-act=start]').disabled = true;
    } else if (sel === 'model') { $('[data-act=start]').disabled = !t.value; }
  });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]'); if (!b || b.tagName === 'INPUT' || b.tagName === 'SELECT') return;
    var act = b.getAttribute('data-act');
    if (act === 'stage') { stageId = b.getAttribute('data-stage'); added = null; render(); syncUrl(); var bd = $('.sb-stages'); if (bd && bd.getBoundingClientRect().top < 0) bd.scrollIntoView({ block: 'start' }); }
    else if (act === 'trim') { trim = b.getAttribute('data-trim'); buildSteps(); added = null; render(); syncUrl(); }
    else if (act === 'swap') { var s = stepOf(b); s.win = (s.win + 3) % s.opts.length; render(); }
    else if (act === 'ask') { if (window.GGCChat && window.GGCChat.open) window.GGCChat.open(); else location.href = 'mailto:support@ggcracing.com?subject=' + encodeURIComponent('Verified-fit part request: ' + v.label + ' - ' + stepOf(b).def.label); }
    else if (act === 'change') { renderPicker(); }
    else if (act === 'garage') { var g = readJSON(GARAGE_KEY, []).filter(function (x) { return x && x.tag && x.make && x.year && !x.handle; }); setVehicle(g[parseInt(b.getAttribute('data-i'), 10)]); }
    else if (act === 'start') {
      var y = $('[data-sel=year]').value, mk = $('[data-sel=make]').value, md = $('[data-sel=model]').value, tag = ((tree[y] || {})[mk] || {})[md];
      if (tag) setVehicle({ year: y, make: mk, model: md, tag: tag, label: y + ' ' + mk + ' ' + md });
    }
    else if (act === 'addall') addAll(b);
  });

  function addAll(btn) {
    var sm = summary(stageId); if (!sm.items.length) return;
    var st = cfg.stages.filter(function (x) { return x.id === stageId; })[0];
    btn.disabled = true; var old = btn.textContent; btn.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: sm.items.map(function (i) { return { id: i.id, quantity: 1 }; }) }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add every part');
        added = { html: '<strong>' + sm.items.length + ' parts added.</strong> ' + esc(st.label) + ' build, ' + money(sm.total) + '. <a href="/cart">View cart</a>' };
        try { window.GGCStageLastAdd = res.j; } catch (e) {}
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { document.querySelectorAll('.header__cart-count').forEach(function (n) { n.textContent = c.item_count; }); });
        render();
      })
      .catch(function (err) { added = { html: esc(err.message || 'Something went wrong. Nothing was added. Please try again.'), err: true }; render(); });
  }

  /* ---------- boot ---------- */
  function boot() {
    var q = qs();
    getJSON(root.getAttribute('data-stages-url') || (BASE + 'ggc-stages.json')).then(function (c) {
      cfg = c;
      if (q.stage && cfg.stages.some(function (s) { return s.id === 'stage' + q.stage; })) stageId = 'stage' + q.stage;
      if (q.year && q.make && q.model) {
        return loadTree().then(function (t) {
          var tag = ((t[q.year] || {})[q.make] || {})[q.model];
          if (tag) return setVehicle({ year: q.year, make: q.make, model: q.model, tag: tag, label: q.year + ' ' + q.make + ' ' + q.model });
          renderPicker('We could not find that vehicle. Pick it below.');
        });
      }
      var sv = vehicleFromStore();
      if (sv) return setVehicle(sv);
      renderPicker();
    }).then(function () {
      if (q.trim && v && shard && (shard.tr[v.tag] || []).indexOf(q.trim) > -1) { trim = q.trim; buildSteps(); render(); }
    }).catch(function () { root.querySelector('[data-stage-body]').innerHTML = '<p class="sb-loading">Could not load the stage builder. Please reload.</p>'; });
  }
  boot();
})();
